import OriginFilter from '@/language/es/components/filter/OriginFilter';
import FieldFilter from '@/language/es/components/filter/FieldFilter';
import OperationFilter from '@/language/es/components/filter/OperationFilter';
import SortingFilter from '@/language/es/components/filter/SortingFilter';
import ComponentTypeFilter from '@/language/es/components/filter/ComponentTypeFilter';
import WidthFilter from '@/language/es/components/filter/WidthFilter';
import HeightFilter from '@/language/es/components/filter/HeightFilter';
import RepliedFilter from '@/language/es/components/filter/RepliedFilter';
import ChannelFilter from '@/language/es/components/filter/ChannelFilter';
import DarkPostFilter from '@/language/es/components/filter/DarkPostFilter';
import PageFilter from '@/language/es/components/filter/PageFilter';
import GenderFilter from '@/language/es/components/filter/GenderFilter';
import PolarityFilter from '@/language/es/components/filter/PolarityFilter';
import UserFilter from '@/language/es/components/filter/UserFilter';
import ContractFilter from '@/language/es/components/filter/ContractFilter';
import DomainsFilter from '@/language/es/components/filter/DomainsFilter';
import DeskTagsFilter from '@/language/es/components/filter/DeskTagsFilter';
import StatusFilter from '@/language/es/components/filter/StatusFilter';
import BotFilter from '@/language/es/components/filter/BotFilter';
import CheckedPosts from '@/language/es/components/filter/CheckedPosts';
import ScheduledFilter from '@/language/es/components/filter/ScheduledFilter';
import CampaignNameFilter from '@/language/es/components/filter/CampaignNameFilter';
import CategoryFilter from '@/language/es/components/filter/CategoryFilter';
import PostByIdFilter from '@/language/es/components/filter/PostByIdFilter';
import OperatorsFilter from '@/language/es/components/filter/OperatorsFilter';
import TeamsFilter from '@/language/es/components/filter/TeamsFilter';
import SacTypeFilter from '@/language/es/components/filter/SacTypeFilter';
import TagView from '@/language/es/components/filter/TagView';
import MultiSelectFilter from '@/language/es/components/filter/MultiSelectFilter';
import NegativationFilter from '@/language/es/components/filter/NegativationFilter';
import RepliersFilter from '@/language/es/components/filter/RepliersFilter';
import StudioMultiSelect from '@/language/es/components/filter/StudioMultiSelect';

export default {
  OriginFilter,
  FieldFilter,
  OperationFilter,
  SortingFilter,
  ComponentTypeFilter,
  WidthFilter,
  HeightFilter,
  RepliedFilter,
  ChannelFilter,
  DarkPostFilter,
  PageFilter,
  GenderFilter,
  PolarityFilter,
  UserFilter,
  ContractFilter,
  DomainsFilter,
  DeskTagsFilter,
  StatusFilter,
  BotFilter,
  CheckedPosts,
  ScheduledFilter,
  CampaignNameFilter,
  CategoryFilter,
  PostByIdFilter,
  OperatorsFilter,
  TeamsFilter,
  SacTypeFilter,
  TagView,
  MultiSelectFilter,
  NegativationFilter,
  RepliersFilter,
  StudioMultiSelect,
};
